import HeroCanvas from "./components/HeroCanvas";
import Navbar from "./components/Navbar";

export default function Home() {
  return (
    <main className="relative w-full h-screen overflow-hidden">
      <Navbar />
      <HeroCanvas />

      <section
        id="home"
        className="hero relative z-[2] flex h-full flex-col items-center justify-center text-center px-4"
      >
        <h1
          className="hero-title notranslate"
          translate="no"
          lang="en"
        >
          Aurora
        </h1>
        <h2
          className="hero-subtitle notranslate"
          translate="no"
          lang="en"
        >
          Interactive
        </h2>
      </section>
    </main>
  );
}